import Hero from "./components/Hero";
import CelebrityExperiences from "./components/CelebrityExperiences";
import SecondarySection from "./components/SecondarySection";
import HoroscopeInsights from "./components/HoroscopeInsights";
import KundliProcess from "./components/KundliProcess";
import WhyChooseUs from "./components/WhyChooseUs";
import SpecialOffer from "./components/SpecialOffer";
import WithoutMatching from "./components/WithoutMatching";
import ConsultationOffer from "./components/ConsultationOffer";
import PricingSection from "./components/PricingSection";
import FAQ from "./components/FAQ";

const KundaliMatchingReport = () => {
  return (
    <div className="min-h-screen">
      <main>
        <Hero />
        <CelebrityExperiences />
        <SecondarySection />
        <PricingSection />
        <HoroscopeInsights />
        <KundliProcess />
        <WhyChooseUs />
        <SpecialOffer />
        <ConsultationOffer />
        <FAQ />
      </main>
    </div>
  );
};

export default KundaliMatchingReport;